"use client";

import uob_cards_data_lib from '../data/uob_cards_data';
import { Link } from "@/i18n/navigation";

function CollegeCard({ slug }) {
    const uob_card_data = uob_cards_data_lib[slug];
    const image = uob_card_data.coverImage.source;

    const CardContent = () => (
        <div className="cursor-pointer transition-all hover:opacity-75">
            <div
                className="relative h-40 w-full rounded-lg bg-cover bg-center bg-no-repeat mb-2"
                style={{
                    backgroundImage: `url(${image})`,
                    backgroundSize: (slug === 'press-release') ? 'contain' : 'cover',
                    backgroundPosition: slug === 'press-release' ? 'center' : 'center',
                }}
            >
                <div
                    className="absolute size-full rounded-lg transition-all duration-300 ease-in-out group-hover:opacity-75"
                    style={{
                        maskImage: `linear-gradient(0deg,#000 1%,rgba(0,0,0,.5) 10%)`,
                        backgroundColor: "#262627"
                    }}
                ></div>
            </div>
            {uob_card_data.name && (
                <h5 className="text-2xl font-semibold group-hover:underline group-hover:transition-all group-hover:ease-in-out">
                    {uob_card_data.name}
                </h5>
            )}
        </div>
    );

    return (
        <Link href={`/about/case-studies/university-of-birmingham/${slug}`}>
            <CardContent />
        </Link>
    );
}

export default CollegeCard;
